<template>
  <div :class="$style.root">
    <p>
      © {{ clientName }}, {{ copyrightLabel }}<span v-if="partnerTitle">, {{ distributionLabel }} {{ partnerTitle }}</span>
    </p>
    <p>
      {{ termsLabel }}
      <span :class="['cursor-pointer', 'kiosk-underline']" @click="emit('terms-click')">
        {{ termsLinkLabel }}
      </span>
    </p>
  </div>
</template>

<script setup lang="ts">
interface Props {
  clientName: string;
  copyrightLabel: string;
  termsLabel: string;
  termsLinkLabel: string;
  partnerTitle?: string;
  distributionLabel?: string;
}

withDefaults(defineProps<Props>(), {
  partnerTitle: undefined,
  distributionLabel: undefined,
});

const emit = defineEmits<{
  'terms-click': [];
}>();
</script>

<style module>
.root {
  font-family: var(--kiosk-font-family-body);
  text-align: center;
  white-space: var(--kiosk-copyright-white-space);
  font-size: var(--kiosk-copyright-font-size);
  padding: var(--kiosk-copyright-padding);
  margin-bottom: 1rem;
}

.root p {
  margin-bottom: 0.1rem;
}

.root p:last-child {
  margin-bottom: 0;
}
</style>
